import React, { memo } from "react";
import { Button } from "../../design/button";

interface BannerActionProps {
  title: string;
  onClick?: () => void;
}

interface BannerProps {
  title?: string;
  message?: string;
  backgroundColor?: string; // Background color for banner
  textColor?: string; // Optional text color, defaults to white
  isVisible: boolean; // Controls visibility of the banner
  onClose?: () => void; // Function to close banner
  action?: BannerActionProps; // Optional action button
}

const Banner: React.FC<BannerProps> = ({
  title,
  message,
  backgroundColor = "bg-blue-500",
  textColor = "text-white",
  isVisible,
  onClose,
  action,
}) => {
  if (!isVisible) return null; // Early return if not visible

  return (
    <div
      className={`flex mb-4 items-center justify-between w-full p-4 rounded-md shadow-md ${backgroundColor}`}
      aria-live="polite"
    >
      {/* Main content: title, message, and action button */}
      <div>
        <div className="flex flex-col gap-2">
          {title && <div className={`${textColor} font-bold`}>{title}</div>}
          {message && <div className={textColor}>{message}</div>}
        </div>
        {action && (
          <Button className="mt-2" onClick={action.onClick}>
            {action.title}
          </Button>
        )}
      </div>

      {/* Close button aligned to the right */}
      {onClose && (
        <button
          className={`ml-4 ${textColor} focus:outline-none`}
          onClick={onClose}
          aria-label="Close banner"
        >
          &times;
        </button>
      )}
    </div>
  );
};

// Memoize the component to avoid unnecessary re-renders
export default memo(Banner);
